import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import axios from "axios";
import { baseUrl } from "../../constants"

interface UserOption {
  id: number;
  username: string;
  profile?: {
    imageUrl?: string;
  };
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  parentId?: number; // mark as optional to prevent crash if not passed
  type?: "position" | "project";
  showSnackbar?: (message: string, severity: "success" | "error") => void; // ✅ new
}

const CreateEditDialogUser: React.FC<Props> = ({
  open,
  onClose,
  onSuccess,
  parentId,
  type,
showSnackbar, // ✅ new
}) => {
  const [users, setUsers] = useState<UserOption[]>([]);
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);

    const accessToken = localStorage.getItem("accessToken");
    
const fetchUsers = async () => {
  if (!parentId || !type) return;

  const url =
    type === "position"
      ? `${baseUrl}/positions/${parentId}/users/not-in`
      : `${baseUrl}/projects/not-in/${parentId}`;

  try {
    const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    const data = Array.isArray(response.data) ? response.data : [];
    console.log("Fetched users:", data); // ✅ For debugging
    setUsers(data);
  } catch (err) {
    console.error("Failed to fetch users:", err);
    setUsers([]);
  }
};

  
  useEffect(() => {
    if (open && parentId && type) {
      fetchUsers();
    }
  }, [open, parentId, type]);

const handleSave = async () => {
  if (!parentId || !type) return;

  const payload = { usersIds: selectedUserIds };

  const url =
    type === "position"
      ? `${baseUrl}/positions/${parentId}/users`
      : `${baseUrl}/projects/${parentId}/users`;

  try {
    await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    onSuccess();
    onClose();

    showSnackbar?.("Done", "success"); // ✅ show success Snackbar
  } catch (error) {
    console.error("Error assigning users:", error);
    showSnackbar?.("Something went wrong", "error"); // ✅ show error Snackbar
  }
};



  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        Add Users to {type === "position" ? "Position" : "Project"}
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Select Users</InputLabel>
          <Select
            multiple
            value={selectedUserIds}
            onChange={(e) => setSelectedUserIds(e.target.value as number[])}
            input={<OutlinedInput label="Select Users" />}
            renderValue={(selected) =>
              users
                .filter((u) => selected.includes(u.id))
                .map((u) => u.username)
                .join(", ")
            }
          >
            {users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                <Checkbox checked={selectedUserIds.includes(user.id)} />
                <img
                  src={user.profile?.imageUrl || "/default-avatar.png"}
                  alt="profile"
                  width={24}
                  height={24}
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: 8,
                  }}
                />
                <ListItemText primary={user.username} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateEditDialogUser;
